var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
var PostLoginPresenter = /** @class */ (function () {
    function PostLoginPresenter(usecase, actions, useCasesStream) {
        this.usecase = usecase;
        this.actions = actions;
        this.useCasesStream = useCasesStream;
        this.symbols = [];
    }
    PostLoginPresenter.prototype.getNFOLive = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.nfoLive.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, null);
        });
    };
    PostLoginPresenter.prototype.getNetPositions = function () {
        var _this = this;
        this.actions.positions.startLoader();
        this.usecase.positions.execute({
            onSuccess: function (data) {
                _this.actions.positions.getPositions(data);
                _this.actions.positions.stopLoader();
            },
            onError: function (error) {
                _this.actions.positions.setError({ isOpen: true, error: error });
                _this.actions.positions.stopLoader();
            },
        }, null);
    };
    PostLoginPresenter.prototype.saveIndicesData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.saveIndices.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    PostLoginPresenter.prototype.portfolioCompositionData = function (req, returnPromise) {
        var _this = this;
        if (returnPromise) {
            return new Promise(function (resolve, reject) {
                _this.usecase.porfolioComposition.execute({
                    onSuccess: function (data) {
                        resolve(data);
                    },
                    onError: function (error) {
                        reject(error);
                    },
                }, req);
            });
        }
        else {
            this.actions.portfolio.startLoader();
            this.actions.portfolio.setError({ isOpen: false, error: undefined });
            this.usecase.porfolioComposition.execute({
                onSuccess: function (data) {
                    _this.actions.portfolio.getPortfolio(data);
                    _this.actions.portfolio.stopLoader();
                },
                onError: function (error) {
                    _this.actions.portfolio.setError({ isOpen: true, error: error });
                    _this.actions.portfolio.stopLoader();
                },
            }, req);
        }
    };
    PostLoginPresenter.prototype.getContributionData = function (req, returnPromise) {
        var _this = this;
        if (returnPromise) {
            return new Promise(function (resolve, reject) {
                _this.usecase.contribution.execute({
                    onSuccess: function (data) {
                        resolve(data);
                    },
                    onError: function (error) {
                        reject(error);
                    },
                }, req);
            });
        }
        else {
            this.actions.contribution.startLoader();
            this.actions.contribution.setError({ isOpen: false, error: undefined });
            this.usecase.contribution.execute({
                onSuccess: function (data) {
                    _this.actions.contribution.getContributionDetails(data);
                    _this.actions.contribution.stopLoader();
                },
                onError: function (error) {
                    _this.actions.contribution.setError({ isOpen: true, error: error });
                    _this.actions.contribution.stopLoader();
                },
            }, req);
        }
    };
    PostLoginPresenter.prototype.getIndexDetails = function () {
        var _this = this;
        this.actions.indexDetails.startLoader();
        this.usecase.indexDetails.execute({
            onSuccess: function (data) {
                var _a, _b;
                if (((_b = (_a = data === null || data === void 0 ? void 0 : data.userIndices) === null || _a === void 0 ? void 0 : _a.bull) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    _this.symbols = data.userIndices.bull
                        .map(function (data) { return data.symbol; })
                        .filter(function (sym) { return sym !== ""; });
                }
                _this.actions.indexDetails.getIndexDetails(data);
                _this.actions.indexDetails.stopLoader();
            },
            onError: function (error) {
                _this.actions.indexDetails.setError({ isOpen: true, error: error });
                _this.actions.indexDetails.stopLoader();
            },
        }, null);
    };
    PostLoginPresenter.prototype.getIndexStreaming = function (subscribe) {
        var _this = this;
        try {
            var symb_1 = subscribe ? this.symbols : [];
            var streamMapKey = [
                streamKeys[0],
                streamKeys[1],
                streamKeys[2],
                streamKeys[3],
            ];
            this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, function (mappedData) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    try {
                        if (symb_1.includes(mappedData.symbol)) {
                            this.actions.indexDetails.updateStream(mappedData);
                        }
                    }
                    catch (error) {
                        console.log(error);
                    }
                    return [2 /*return*/];
                });
            }); }, symb_1, streamMapKey);
        }
        catch (error) {
            console.log(error);
        }
    };
    PostLoginPresenter.prototype.getMarketMapPL = function (req, returnPromise) {
        var _this = this;
        if (returnPromise) {
            return new Promise(function (resolve, reject) {
                _this.usecase.marketMapPL.execute({
                    onSuccess: function (data) {
                        resolve(data);
                    },
                    onError: function (error) {
                        reject(error);
                    },
                }, req);
            });
        }
        else {
            this.actions.marketMapPL.startLoader();
            this.actions.marketMapPL.setError({ isOpen: false, error: undefined });
            this.usecase.marketMapPL.execute({
                onSuccess: function (data) {
                    _this.actions.marketMapPL.getMarketMapPL(data);
                    _this.actions.marketMapPL.stopLoader();
                },
                onError: function (error) {
                    _this.actions.marketMapPL.setError({ isOpen: true, error: error });
                    _this.actions.marketMapPL.stopLoader();
                },
            }, req);
        }
    };
    PostLoginPresenter.prototype.exploreTrading = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.exploreTrading.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    PostLoginPresenter.prototype.getServiceList = function (req) {
        var _this = this;
        this.actions.serviceList.startLoader();
        this.usecase.serviceList.execute({
            onSuccess: function (data) {
                _this.actions.serviceList.getServiceList(data);
                _this.actions.serviceList.stopLoader();
            },
            onError: function (error) {
                _this.actions.serviceList.setError({ isOpen: true, error: error });
                _this.actions.serviceList.stopLoader();
            },
        }, req);
    };
    PostLoginPresenter.prototype.getDiversifyPortfolio = function () {
        var _this = this;
        this.actions.diversifyPortfolio.startLoader();
        this.usecase.diversifyPortfolio.execute({
            onSuccess: function (data) {
                _this.actions.diversifyPortfolio.getDiversifyPortfolio(data);
                _this.actions.diversifyPortfolio.stopLoader();
            },
            onError: function (error) {
                _this.actions.diversifyPortfolio.setError({ isOpen: true, error: error });
                _this.actions.diversifyPortfolio.stopLoader();
            },
        }, null);
    };
    PostLoginPresenter.prototype.getAllIndicesList = function () {
        var _this = this;
        this.actions.allIndicesList.startLoader();
        this.usecase.allIndicesList.execute({
            onSuccess: function (data) {
                _this.actions.allIndicesList.getAllIndicesList(data);
                _this.actions.allIndicesList.stopLoader();
            },
            onError: function (error) {
                _this.actions.allIndicesList.setError({ isOpen: true, error: error });
                _this.actions.allIndicesList.stopLoader();
            },
        }, null);
    };
    PostLoginPresenter.prototype.getUpcomingEvents = function () {
        var _this = this;
        this.actions.upcomingEvents.startLoader();
        this.actions.upcomingEvents.setError({ isOpen: false, error: undefined });
        this.usecase.upcomingEvents.execute({
            onSuccess: function (data) {
                _this.actions.upcomingEvents.getUpcomingEvents(data);
                _this.actions.upcomingEvents.stopLoader();
            },
            onError: function (error) {
                _this.actions.upcomingEvents.setError({ isOpen: true, error: error });
                _this.actions.upcomingEvents.stopLoader();
            },
        }, null);
    };
    return PostLoginPresenter;
}());
export default PostLoginPresenter;
